import { render } from "./SettingsCardGlobal.vue?vue&type=template&id=e7315d64&scoped=true"
import script from "./SettingsCardGlobal.vue?vue&type=script&lang=js"
export * from "./SettingsCardGlobal.vue?vue&type=script&lang=js"

import "./SettingsCardGlobal.vue?vue&type=style&index=0&id=e7315d64&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7315d64"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QForm,QCard,QCheckbox,QInput,QBtn});
